import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { AccessRequirement } from '@app/core/models/access-requirement.model';
import { SessionStorageKeys } from '@app/core/models/configuration/sessionstorage-keys.model';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { MissingInvoiceNumberContentResolver } from '@app/core/resolvers/imports/imports-missing-invoice-number-content-resolver.service.';
import { MissingInvoiceNumberResolver } from '@app/core/resolvers/imports/imports-missing-invoice-number-resolver.service.';
import { MissingInvoiceNumberSearchResolver } from '@app/core/resolvers/imports/imports-missing-invoice-number-search-resolver.service';
import { ExportInvoicesActivityComponent } from './export-invoices-activity/export-invoices-activity.component';
import { AnalysisMissingInvoiceNumberComponent } from './missing-invoice-number/analysis-missing-invoice-number.component';
import { AnalysisMissingInvoiceNumberPdfViewerComponent } from './missing-invoice-number/pdf-viewer/analysis-missing-invoice-number-pdf-viewer.component';

const routes: Routes = [
    {
        path: 'analysis/missing-invoice-numbers',
        component: AnalysisMissingInvoiceNumberComponent,
        resolve: {
            dataSource: MissingInvoiceNumberSearchResolver
        },
        data: {
            requiredMembership: [AccessRequirement.AnalyticalMembership],
            searchFilterKey: SessionStorageKeys.ANALYSIS_MISSING_INVOICE_NUMBERS,
            configKey: TableColumnsConfigKey.MISSINGINVOICENUMBERS
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'analysis/missing-invoice-numbers/detail-pdf/:id',
        component: AnalysisMissingInvoiceNumberPdfViewerComponent,
        resolve: {
            missingInvoiceNumber: MissingInvoiceNumberResolver,
            document: MissingInvoiceNumberContentResolver
        },
        data: {
            requiredMembership: [AccessRequirement.AnalyticalMembership],
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'analysis/export-invoices-activity',
        component: ExportInvoicesActivityComponent,
        data: {
            requiredMembership: [AccessRequirement.AnalyticalMembership],
        },
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AnalysisRoutingModule { }
